import { render } from "./faculty.vue?vue&type=template&id=11b1ce1a&scoped=true"
import script from "./faculty.vue?vue&type=script&lang=js"
export * from "./faculty.vue?vue&type=script&lang=js"

import "./faculty.vue?vue&type=style&index=0&id=11b1ce1a&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-11b1ce1a"

export default script